import { useMsal } from '@azure/msal-react';
import { useIonRouter } from '@ionic/react';
import { useCallback } from 'react';
import { config } from '../services/msal/msal.services';
import { routes, routesNested } from '../constants/routes';

type AsyncCallback = () => Promise<void>;

export const useLoginCallback = (): AsyncCallback => {
  const { instance } = useMsal();
  const router = useIonRouter();

  const loginCallback = useCallback(async () => {
    /* put nothing after the redirect instruction. It won't execute */
    const rdvPending =
      router.routeInfo.pathname.includes(routes.appointment) &&
      router.routeInfo.pathname !== routesNested.appointment.connectionStep;
    await instance.loginRedirect({
      scopes: [],
      redirectStartPage: rdvPending
        ? routesNested.resume
        : router.routeInfo.pathname
    });
  }, [instance, router.routeInfo.pathname]);
  return loginCallback;
};

export const useLogoutCallback = (): AsyncCallback => {
  const { instance } = useMsal();
  const logoutCallback = useCallback(async () => {
    const account = instance.getAllAccounts()[0];
    await instance.logoutRedirect({
      account,
      postLogoutRedirectUri: config.postLogoutRedirectUri
    });
  }, [instance]);
  return logoutCallback;
};

export const useChangePasswordCallback = (): AsyncCallback => {
  const { instance } = useMsal();
  const changePasswordCallback = useCallback(async () => {
    await instance.loginRedirect({
      authority: config.passwordChangeAuthority,
      redirectUri: config.postChangePasswordRedirectUri,
      scopes: []
    });
  }, [instance]);
  return changePasswordCallback;
};
